import React from 'react';
import { Page, BText, Badge } from '../../components';

export const DemoHome = () => {
  return (
    <Page title={'Demo Page'}>
      <BText>Here to show how to use the internal components</BText>

      <Badge value="10" containerStyle={{ width: 90, marginTop: 20 }}>
        Notification
      </Badge>
    </Page>
  );
};
